export default __webpack_public_path__ + "static/media/renewal-header-base.ae82f216.svg";